export const ADD_NEW_FORM_CHANGED = "ADD_NEW_FORM_CHANGED";
export const ADD_NEW_FORM = "ADD_NEW_FORM";
export const ADD_NEW_FIELD = "ADD_NEW_FIELD";
export const EDIT_INPUT_FIELD = "EDIT_INPUT_FIELD";
export const DELETE_FORM = "DELETE_FORM";
export const DELETE_FIELD = "DELETE_FIELD";
export const ADD_SHARED_FORM_TO_STATE = "ADD_SHARED_FORM_TO_STATE";
